module.exports = __webpack_public_path__ + "static/media/umrah-package-2.b9bb7ba9.jpg";